import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetClientePorIdService } from '@/features/clientes/services/get-cliente-por-id.service'
import { clientePorCpfPropostaKeys } from '@/features/clientes/utils'
import type { TCliente } from '@/types/cliente'

export const useClientePorId = (id: string, enabled: boolean): UseQueryResult<TCliente, AxiosError> => {
  return useQuery({
    queryKey: clientePorCpfPropostaKeys.obter(id),
    queryFn: async () => new GetClientePorIdService().execute({ id }).then((res) => res.data),
    enabled: enabled,
  })
}
